export { NavigationDesktop as Desktop } from "./navigationDesktop";



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/navigation/navigation.ts
// module id = bN4f
// module chunks = 2